<template>
  <div class="magazine-reviews">
    <div class="magazine-reviews__content">
      <h3>Reviews</h3>
      <transition-group v-if="activeReview"
                        class="magazine-review"
                        tag="div"
                        name="fade">
        <blockquote key="review-quote"
                    :cite="activeReview.author">
          &quot;{{ activeReview.reviewContent }}&quot;
        </blockquote>
        <div key="review-author">
          <div class="magazine-review__author">
            {{ activeReview.author }}
          </div>
          <div class="magazine-review__jobRole">
            {{ activeReview.jobRole }}
          </div>
        </div>
      </transition-group>
      <p v-else>
        There are currently no reviews for this magazine.
      </p>
    </div>
    <div class="magazine-reviews__navigation">
      <span
        v-for="(n, i) in navigation"
        :key="i"
        :class="['magazine-reviews__index', { 'magazine-reviews__index--active': n.isActive }]"
        tabindex="0"
        @click="setActiveReview(i)"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "MagazineReviews",
  props: {
    reviews: {
      type: Array,
      default: () => [],
      validator: reviews => reviews.every( review => ["author", "jobRole", "reviewContent"].every( key => key in review ) ),
    },
  },
  data () {
    return {
      activeReviewIndex: 0,
    };
  },
  computed: {
    activeReview () {
      return this.reviews[this.activeReviewIndex];
    },
    navigation () {
      return this.reviews.map( ( r, i ) => ( { isActive: this.activeReviewIndex === i } ) );
    },
  },
  methods: {
    setActiveReview ( index ) {
      this.activeReviewIndex = index;
    },
    isActiveReview ( index ) {
      return this.activeReviewIndex === index;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../Styles/utils/colors.less";
.fade-enter-active,
.fade-leave-active {
  overflow: hidden;
  visibility: visible;
  opacity: 1;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  visibility: hidden;
}

.magazine-reviews {
  padding: 1.5rem;
  z-index: 0;
  position: relative;
  width: 370px;
  min-height: 420px;
  margin: auto;
  display: flex;
  flex-flow: column;
  justify-content: space-between;

  > * {
    margin-top: 1.5rem;
  }

  &__content {
    > h3 {
      font-size: 1.25rem;
    }

    * {
      text-align: center;
    }

    > * + * {
      margin-top: 1.5rem;
    }
  }

  &::after {
    content: "";
    z-index: -1;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.2;
    background-color: @color-accent-7;
    transform: rotate(2deg);
  }

  &::before {
    content: "";
    z-index: -2;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.2;
    background-color: @color-accent-8;
    transform: rotate(-2deg);
  }

  &__navigation {
    display: flex;
    justify-content: center;

    > span + span {
      margin-left: 0.5rem;
    }
  }

  &__index {
    cursor: pointer;
    height: 0.75rem;
    width: 0.75rem;
    border-radius: 50%;
    background-color: @color-accent-8;

    &--active {
      background-color: @color-accent-2;
    }
  }
}

.magazine-review {
  > * {
    margin-top: 1.5rem;
  }

  > blockquote {
    font-size: 1rem;
    font-style: italic;
    text-align: left;
    margin-bottom: 0;
  }

  &__author {
    font-size: 1.25rem;
    line-height: 1rem;
    color: @color-accent-2;
  }

  &__jobRole {
    font-size: 1.25rem;
    color: @color-accent-1;
  }
}
</style>
